import React from 'react';
import { Stacker, TypographyHeading, ProgressBar, Paper } from '@honeycomb/ui-core';
import { useProgressBar } from './useProgressBar';
export function HotelInterstitialProgressBar({ messages, totalDuration, progressBarComplete, }) {
    const { currentMessage, progress } = useProgressBar(messages, totalDuration, progressBarComplete);
    const value = Math.floor(progress);
    const complete = progress === 100;
    return (React.createElement(Stacker, { spacing: { xs: 8, m: 12 }, justifyContent: "center", alignSelf: "stretch" },
        React.createElement(TypographyHeading, { size: "xs", color: "text.body", align: "center" }, currentMessage),
        React.createElement(Paper, { p: 3, br: "36px" },
            React.createElement(ProgressBar, { value: value, size: "xl", color: complete ? 'system.success.base' : undefined }, `${value}%`))));
}
